import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService } from 'ng-jhipster';

import { Historique } from './historique.model';
import { HistoriquePopupService } from './historique-popup.service';
import { HistoriqueService } from './historique.service';

@Component({
    selector: 'jhi-historique-delete-dialog',
    templateUrl: './historique-delete-dialog.component.html'
})
export class HistoriqueDeleteDialogComponent {

    historique: Historique;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private historiqueService: HistoriqueService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['historique']);
    }

    clear () {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete (id: number) {
        this.historiqueService.delete(id).subscribe(response => {
            this.eventManager.broadcast({
                name: 'historiqueListModification',
                content: 'Deleted an historique'
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'jhi-historique-delete-popup',
    template: ''
})
export class HistoriqueDeletePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor (
        private route: ActivatedRoute,
        private historiquePopupService: HistoriquePopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            this.modalRef = this.historiquePopupService
                .open(HistoriqueDeleteDialogComponent, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/historique/historique-delete-dialog.component.ts